<template>
  <section class="w">
    <v-card>
      <v-card-title class="chart-title" primary-title>
        Registrations by School Gender
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="pagination"
        hide-default-footer
        disable-sort
        class="dataTable"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td class="text-center">{{ props.item.month }}</td>
          <td class="text-center">{{ props.item.overall }}</td>
        </template>
      </v-data-table>
      <div class="text-center pt-2" v-if="pages > 1">
        <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
      </div>
    </v-card>
  </section>
</template>

<script>
export default {
  data() {
    return {
      headers: [
        {
          text: 'School Gender',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        { text: 'Month', align: 'center', sortable: true, value: 'month' },
        { text: 'Overall', align: 'center', sortable: true, value: 'overall' }
      ],
      items: [
        {
          name: 'Co-educational',
          month: 60,
          overall: 11
        },
        {
          name: 'Boys',
          month: 45,
          overall: 9
        },
        {
          name: 'Girls',
          month: 44,
          overall: 7
        }
      ],
      pagination: {
        rowsPerPage: 5
      }
    }
  },
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0

      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
    }
  }
}
</script>

<style lang="scss">
.gender-data-table-component {
  .v-btn.v-btn--disabled {
    display: none !important;
  }
  .dataTable {
    height: 300px !important;
  }
}
</style>
